import { render } from "./json.vue?vue&type=template&id=9b931fa6"
import script from "./json.vue?vue&type=script&lang=js"
export * from "./json.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__